import * as yup from 'yup';

import { FORM_KEYS } from 'shared/constant';

const { AGREEMENT } = FORM_KEYS;

const formAgreementSchema = intl => yup.object().shape({
  [AGREEMENT.AOF_KYC]: yup
    .array()
    .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' }))
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        // console.log('value.length', value.length);
        if (value.length === 3) return true;
        return false;
      },
    ),
  [AGREEMENT.PROFILE]: yup
    .array()
    .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' }))
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (value.length === 2) return true;
        return false;
      },
    ),
  [AGREEMENT.AOF_KYC_PROFILE_SIGNATURE]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
});

export default formAgreementSchema;
